import { render, staticRenderFns } from "./NotentransferDetailSV.vue?vue&type=template&id=31cfbe6e&"
import script from "./NotentransferDetailSV.vue?vue&type=script&lang=js&"
export * from "./NotentransferDetailSV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports